import FDialog from './FDialog.vue'

export default FDialog
